import { Field, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/** A Field.Label that appends the themed red required asterisk.
 *  The asterisk only renders when the enclosing <Field.Root> has `required`. */
export function RequiredLabel({ children }: { children: ReactNode }) {
  return (
    <Field.Label>
      {children}
      <Field.RequiredIndicator />
    </Field.Label>
  );
}

/** One-line legend explaining the asterisk. Single source for the copy. */
export function RequiredLegend() {
  return (
    <Text fontSize="xs" color="fg.muted">
      <Text as="span" color="fg.error">
        *
      </Text>{' '}
      Campos obligatorios
    </Text>
  );
}
